import React, { useState, useEffect } from "react";
import { CrudForm } from "elentari";
import * as R from "ramda";
import Grid from "@material-ui/core/Grid";
import { Checkbox } from "final-form-material-ui";
import { Field } from "react-final-form";
import { servicosApi, clienteServicosApi } from "../../services/Api";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormControl from "@material-ui/core/FormControl";

export function ClienteServicosForm(props) {
  const [servicos, setServicos] = useState([]);

  const fetchServicos = async () => {
    const response = await servicosApi.getList();
    if (response.ok) {
      setServicos(response.data);
    }
  };
  const getItems = async () => {
    const { params } = props.match;
    const response = await clienteServicosApi.getList({
      where: { clienteId: params.id },
    });
    if (response.ok) {
      const { data } = response;
      return {
        servico: data.map(R.prop("servicoId")),
      };
    }
  };
  const handleSubmit = async (data) => {
    const { params } = props.match;
    const clienteServicosResponse = await clienteServicosApi.getList({
      where: { clienteId: params.id },
    });
    if (clienteServicosResponse.ok) {
      await Promise.all(
        clienteServicosResponse.data.map((obj) =>
          clienteServicosApi.deleteF(obj.id)
        )
      );
    }
    const promises = data.servico.map((servicoId) =>
      clienteServicosApi.create({
        clienteId: Number(params.id),
        servicoId: Number(servicoId),
      })
    );
    const responses = await Promise.all(promises);
    if (R.all(R.prop("ok"))(responses)) {
      return {
        ok: true,
      };
    }
    return { ok: false };
  };

  useEffect(() => {
    fetchServicos();
  }, []);

  return (
    <CrudForm
      history={props.history}
      getItem={getItems}
      onSubmit={handleSubmit}
    >
      <FormControl component="fieldset" style={{ width: "100%" }}>
        <FormGroup row>
          <Grid container style={{ width: "100%" }}>
            {servicos.map((item) => (
              <Grid item sm={4} key={item.nome}>
                <FormControlLabel
                  label={item.nome}
                  control={
                    <Field
                      color="primary"
                      name="servico"
                      value={item.id}
                      type="checkbox"
                      component={Checkbox}
                    />
                  }
                />
              </Grid>
            ))}
          </Grid>
        </FormGroup>
      </FormControl>
    </CrudForm>
  );
}
